import api from './api';

export const getOrders = async (params = {}) => {
  try {
    // If status is provided, include it in the params
    const { status, ...rest } = params;
    const queryParams = { ...rest };
    if (status !== undefined && status !== null) {
      queryParams.status = status;
    }
    const response = await api.get('/admin/orders/', { params: queryParams });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch orders');
  }
};

export const getOrder = async (id) => {
  try {
    const response = await api.get(`/admin/orders/${id}/`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch order');
  }
};

export const updateOrder = async (id, orderData) => {
  try {
    const response = await api.put(`/admin/orders/${id}/`, orderData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to update order');
  }
};

export const deleteOrder = async (id) => {
  try {
    await api.delete(`/admin/orders/${id}/`);
    return true;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to delete order');
  }
};

export const getOrderStats = async () => {
  try {
    const response = await api.get('/admin/orders/stats/');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch order stats');
  }
};

export const getOrderStatusCounts = async () => {
  try {
    const response = await api.get('/admin/orders/status-counts/');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch order status counts');
  }
}; 

export const getPurchasingManagementOptions = async (includeOwners = false) => {
  try {
    const params = includeOwners ? { include_owners: 1 } : undefined;
    const response = await api.get('/admin/orders/purchasing-options/', { requiresAuth: true, params });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail || error.response?.data?.message || 'Failed to fetch purchasing options';
    const hint = error.response?.status === 403 ? ' (Your admin role may be missing permission.)' : '';
    throw new Error(`${detail}${hint}`);
  }
};

export const getPurchasingPlatforms = async () => {
  try {
    const response = await api.get('/admin/orders/purchasing-platforms/', { requiresAuth: true });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail || error.response?.data?.message || 'Failed to fetch purchasing platforms';
    const hint = error.response?.status === 403 ? ' (Your admin role may be missing permission.)' : '';
    throw new Error(`${detail}${hint}`);
  }
};

export const createPurchasingPlatform = async (payload) => {
  try {
    const response = await api.post('/admin/orders/purchasing-platforms/', payload, { requiresAuth: true });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail || error.response?.data?.message || 'Failed to create purchasing platform';
    const hint = error.response?.status === 403 ? ' (Your admin role may be missing permission.)' : '';
    throw new Error(`${detail}${hint}`);
  }
};

export const updatePurchasingPlatform = async (id, payload) => {
  try {
    const response = await api.patch(`/admin/orders/purchasing-platforms/${id}/`, payload, { requiresAuth: true });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail || error.response?.data?.message || 'Failed to update purchasing platform';
    const hint = error.response?.status === 403 ? ' (Your admin role may be missing permission.)' : '';
    throw new Error(`${detail}${hint}`);
  }
};

export const deletePurchasingPlatform = async (id) => {
  try {
    const response = await api.delete(`/admin/orders/purchasing-platforms/${id}/`, { requiresAuth: true });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail || error.response?.data?.message || 'Failed to delete purchasing platform';
    const hint = error.response?.status === 403 ? ' (Your admin role may be missing permission.)' : '';
    throw new Error(`${detail}${hint}`);
  }
};

export const getPurchasingAccounts = async () => {
  try {
    const response = await api.get('/admin/orders/purchasing-accounts/', { requiresAuth: true });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail || error.response?.data?.message || 'Failed to fetch purchasing accounts';
    const hint = error.response?.status === 403 ? ' (Your admin role may be missing permission.)' : '';
    throw new Error(`${detail}${hint}`);
  }
};

export const createPurchasingAccount = async (payload) => {
  try {
    const response = await api.post('/admin/orders/purchasing-accounts/', payload, { requiresAuth: true });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail || error.response?.data?.message || 'Failed to create purchasing account';
    const hint = error.response?.status === 403 ? ' (Your admin role may be missing permission.)' : '';
    throw new Error(`${detail}${hint}`);
  }
};

export const updatePurchasingAccount = async (id, payload) => {
  try {
    const response = await api.patch(`/admin/orders/purchasing-accounts/${id}/`, payload, { requiresAuth: true });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail || error.response?.data?.message || 'Failed to update purchasing account';
    const hint = error.response?.status === 403 ? ' (Your admin role may be missing permission.)' : '';
    throw new Error(`${detail}${hint}`);
  }
};

export const deletePurchasingAccount = async (id) => {
  try {
    const response = await api.delete(`/admin/orders/purchasing-accounts/${id}/`, { requiresAuth: true });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail || error.response?.data?.message || 'Failed to delete purchasing account';
    const hint = error.response?.status === 403 ? ' (Your admin role may be missing permission.)' : '';
    throw new Error(`${detail}${hint}`);
  }
};
